import { STORAGE_KEYS } from './constants';

/**
 * Récupère le ticket Alfresco depuis le localStorage
 */
export const getTicket = () => {
  return localStorage.getItem(STORAGE_KEYS.ALFRESCO_TICKET);
};

/**
 * Stocke le ticket Alfresco dans le localStorage
 */
export const setTicket = (ticket) => {
  localStorage.setItem(STORAGE_KEYS.ALFRESCO_TICKET, ticket);
};

/**
 * Supprime le ticket Alfresco du localStorage
 */
export const clearTicket = () => {
  localStorage.removeItem(STORAGE_KEYS.ALFRESCO_TICKET);
  localStorage.removeItem(STORAGE_KEYS.USER_INFO);
};

/**
 * Déconnexion (alias pour clearTicket)
 */
export const logout = () => {
  clearTicket();
};

/**
 * Vérifie si l'utilisateur est authentifié
 */
export const isAuthenticated = () => {
  return !!getTicket();
};

/**
 * Récupère les informations utilisateur depuis le localStorage
 */
export const getUserInfo = () => {
  const userInfo = localStorage.getItem(STORAGE_KEYS.USER_INFO);
  return userInfo ? JSON.parse(userInfo) : null;
};

/**
 * Stocke les informations utilisateur dans le localStorage
 */
export const setUserInfo = (userInfo) => {
  localStorage.setItem(STORAGE_KEYS.USER_INFO, JSON.stringify(userInfo));
};

